module.exports = "https://static.wmbcdn.com/uniweb/images/a9846d34ca70b85d0b4993de254f2dca.svg";